// Country codes with flag codes and validation rules
// Using ISO country codes for flag images (more reliable than emojis)
export const countryCodes = [
    { code: "+1", flagCode: "US", name: "United States", dialCode: "1", pattern: /^\+1[2-9]\d{2}[2-9]\d{6}$/ },
    { code: "+1", flagCode: "CA", name: "Canada", dialCode: "1", pattern: /^\+1[2-9]\d{2}[2-9]\d{6}$/ },
    { code: "+44", flagCode: "GB", name: "United Kingdom", dialCode: "44", pattern: /^\+44\d{10,11}$/ },
    { code: "+27", flagCode: "ZA", name: "South Africa", dialCode: "27", pattern: /^\+27\d{9}$/ },
    { code: "+33", flagCode: "FR", name: "France", dialCode: "33", pattern: /^\+33[1-9]\d{8}$/ },
    { code: "+49", flagCode: "DE", name: "Germany", dialCode: "49", pattern: /^\+49\d{10,11}$/ },
    { code: "+39", flagCode: "IT", name: "Italy", dialCode: "39", pattern: /^\+39\d{9,10}$/ },
    { code: "+34", flagCode: "ES", name: "Spain", dialCode: "34", pattern: /^\+34\d{9}$/ },
    { code: "+31", flagCode: "NL", name: "Netherlands", dialCode: "31", pattern: /^\+31\d{9}$/ },
    { code: "+32", flagCode: "BE", name: "Belgium", dialCode: "32", pattern: /^\+32\d{9}$/ },
    { code: "+41", flagCode: "CH", name: "Switzerland", dialCode: "41", pattern: /^\+41\d{9}$/ },
    { code: "+46", flagCode: "SE", name: "Sweden", dialCode: "46", pattern: /^\+46\d{9}$/ },
    { code: "+47", flagCode: "NO", name: "Norway", dialCode: "47", pattern: /^\+47\d{8}$/ },
    { code: "+45", flagCode: "DK", name: "Denmark", dialCode: "45", pattern: /^\+45\d{8}$/ },
    { code: "+358", flagCode: "FI", name: "Finland", dialCode: "358", pattern: /^\+358\d{9,10}$/ },
    { code: "+351", flagCode: "PT", name: "Portugal", dialCode: "351", pattern: /^\+351\d{9}$/ },
    { code: "+353", flagCode: "IE", name: "Ireland", dialCode: "353", pattern: /^\+353\d{9}$/ },
    { code: "+48", flagCode: "PL", name: "Poland", dialCode: "48", pattern: /^\+48\d{9}$/ },
    { code: "+420", flagCode: "CZ", name: "Czech Republic", dialCode: "420", pattern: /^\+420\d{9}$/ },
    { code: "+36", flagCode: "HU", name: "Hungary", dialCode: "36", pattern: /^\+36\d{9}$/ },
    { code: "+43", flagCode: "AT", name: "Austria", dialCode: "43", pattern: /^\+43\d{10,11}$/ },
    { code: "+61", flagCode: "AU", name: "Australia", dialCode: "61", pattern: /^\+61\d{9}$/ },
    { code: "+64", flagCode: "NZ", name: "New Zealand", dialCode: "64", pattern: /^\+64\d{8,9}$/ },
    { code: "+81", flagCode: "JP", name: "Japan", dialCode: "81", pattern: /^\+81\d{10,11}$/ },
    { code: "+82", flagCode: "KR", name: "South Korea", dialCode: "82", pattern: /^\+82\d{9,10}$/ },
    { code: "+86", flagCode: "CN", name: "China", dialCode: "86", pattern: /^\+86\d{11}$/ },
    { code: "+91", flagCode: "IN", name: "India", dialCode: "91", pattern: /^\+91\d{10}$/ },
    { code: "+971", flagCode: "AE", name: "UAE", dialCode: "971", pattern: /^\+971\d{9}$/ },
    { code: "+966", flagCode: "SA", name: "Saudi Arabia", dialCode: "966", pattern: /^\+966\d{9}$/ },
    { code: "+52", flagCode: "MX", name: "Mexico", dialCode: "52", pattern: /^\+52\d{10}$/ },
    { code: "+55", flagCode: "BR", name: "Brazil", dialCode: "55", pattern: /^\+55\d{10,11}$/ },
    { code: "+54", flagCode: "AR", name: "Argentina", dialCode: "54", pattern: /^\+54\d{10}$/ },
    { code: "+7", flagCode: "RU", name: "Russia", dialCode: "7", pattern: /^\+7\d{10}$/ },
    { code: "+90", flagCode: "TR", name: "Turkey", dialCode: "90", pattern: /^\+90\d{10}$/ },
    { code: "+20", flagCode: "EG", name: "Egypt", dialCode: "20", pattern: /^\+20\d{10}$/ },
    { code: "+234", flagCode: "NG", name: "Nigeria", dialCode: "234", pattern: /^\+234\d{10}$/ },
    { code: "+254", flagCode: "KE", name: "Kenya", dialCode: "254", pattern: /^\+254\d{9}$/ },
    { code: "+380", flagCode: "UA", name: "Ukraine", dialCode: "380", pattern: /^\+380\d{9}$/ },
    { code: "+65", flagCode: "SG", name: "Singapore", dialCode: "65", pattern: /^\+65\d{8}$/ },
    { code: "+60", flagCode: "MY", name: "Malaysia", dialCode: "60", pattern: /^\+60\d{9,10}$/ },
    { code: "+66", flagCode: "TH", name: "Thailand", dialCode: "66", pattern: /^\+66\d{9}$/ },
    { code: "+62", flagCode: "ID", name: "Indonesia", dialCode: "62", pattern: /^\+62\d{9,11}$/ },
    { code: "+84", flagCode: "VN", name: "Vietnam", dialCode: "84", pattern: /^\+84\d{9,10}$/ },
    { code: "+63", flagCode: "PH", name: "Philippines", dialCode: "63", pattern: /^\+63\d{10}$/ },
];

// Sort by country name for easier selection
countryCodes.sort((a, b) => a.name.localeCompare(b.name));

// Helper function to get flag image URL
export const getFlagUrl = (flagCode) => {
    return `https://flagcdn.com/w40/${flagCode.toLowerCase()}.png`;
};

// Find country by dial code
export const findCountryByCode = (dialCode) => {
    return countryCodes.find(country => 
        country.dialCode === dialCode || 
        country.code === `+${dialCode}` ||
        country.code === dialCode
    );
};

// Find country by phone number (extract dial code from number)
export const findCountryByPhoneNumber = (phoneNumber) => {
    if (!phoneNumber || !phoneNumber.startsWith('+')) return null;
    
    // Try to match longest dial codes first
    const sortedByLength = [...countryCodes].sort((a, b) => b.dialCode.length - a.dialCode.length);
    
    for (const country of sortedByLength) {
        if (phoneNumber.startsWith(`+${country.dialCode}`)) {
            return country;
        }
    }
    
    return null;
};

// Validate phone number based on country
export const validatePhoneNumber = (phoneNumber, countryCode = null) => {
    if (!phoneNumber) return { valid: false, error: "Phone number is required" };
    
    // Remove spaces and dashes for validation
    const cleaned = phoneNumber.replace(/[\s-]/g, '');
    
    // If no country code provided, try to detect from number
    const country = countryCode || findCountryByPhoneNumber(cleaned);
    
    if (!country) {
        // Fallback: basic international format validation
        if (!cleaned.startsWith('+')) {
            return { valid: false, error: "Phone number must start with country code (e.g., +27)" };
        }
        if (cleaned.length < 10 || cleaned.length > 15) {
            return { valid: false, error: "Phone number must be between 10 and 15 digits including country code" };
        }
        if (!/^\+[0-9]{9,14}$/.test(cleaned)) {
            return { valid: false, error: "Phone number contains invalid characters" };
        }
        return { valid: true, error: null };
    }
    
    // Validate against country-specific pattern
    if (country.pattern && !country.pattern.test(cleaned)) {
        return { 
            valid: false, 
            error: `Please enter a valid ${country.name} phone number` 
        };
    }
    
    return { valid: true, error: null };
};

// Format phone number with country code
export const formatPhoneNumber = (phoneNumber, country) => {
    if (!phoneNumber) return "";
    
    // Remove all non-digit characters except +
    let cleaned = phoneNumber.replace(/[^\d+]/g, '');
    
    // If country is provided and number doesn't start with country code, add it
    if (country && !cleaned.startsWith('+')) {
        // Remove leading zeros if present
        cleaned = cleaned.replace(/^0+/, '');
        cleaned = `+${country.dialCode}${cleaned}`;
    } else if (!cleaned.startsWith('+') && cleaned.length > 0) {
        // If no country provided but number doesn't start with +, assume it's a local number
        // Don't modify it, let the user decide
        cleaned = cleaned;
    }
    
    return cleaned;
};

// Get default country (you can change this based on your business location)
export const getDefaultCountry = () => {
    // Default to South Africa based on the codebase context
    return countryCodes.find(c => c.dialCode === "27") || countryCodes[0];
};
